/**
 * OAuth2 Connector Component
 * Form component for OAuth2 authentication configuration
 */

import { FormDescription } from '@/components/ui/form'
import { ExternalLink } from 'lucide-react'

/**
 * OAuth2 connector content component
 */
export function OAuth2Connector() {
  return (
    <div className="space-y-3">
      <div className="flex items-center gap-2 text-sm text-blue-600">
        <ExternalLink className="size-4" />
        <span className="font-medium">OAuth2 Authorization Required</span>
      </div>
      
      <FormDescription className="text-sm">
        When you click
        <strong className="mx-1">Save Integration</strong>, 
        a new window will open where you can securely authorize the connection to your selected service.
        The authorization window will close automatically once completed.
      </FormDescription>
      
      <div className="rounded-md bg-blue-50 border border-blue-200 p-3 text-xs text-blue-700">
        <strong>Note:</strong> Make sure popups are enabled for this site. 
        Your browser may block the authorization window otherwise.
      </div>
    </div>
  )
}